import { h, render, Component } from 'preact';


const shortlist = (props) => (
	<svg id="shortlist" version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" viewBox="0 0 72 72" class={props.class}>
		<path d="M49.8,5.4C61.1,5.4,70,14.3,70,25.6c0,4-1.1,7.9-3.2,11.8c-3.7,6.9-8.6,11.9-24.1,26.1L36,69.5l-2.3-2.1l-4.4-4c-15.5-14-20.4-19.1-24.1-26C3.1,33.5,2,29.6,2,25.6C2,14.3,10.9,5.4,22.2,5.4c5,0,9.9,1.8,13.8,5C39.8,7.2,44.7,5.4,49.8,5.4z M38.2,58.4C53,44.9,57.7,40.1,60.9,34.1c1.6-2.9,2.3-5.7,2.3-8.6c0-7.5-5.9-13.4-13.4-13.4c-4.2,0-8.4,2-11.2,5.2l-2.6,3l-2.6-3c-2.7-3.2-6.9-5.2-11.2-5.2c-7.5,0-13.4,5.9-13.4,13.4c0,2.9,0.8,5.6,2.4,8.6c3.2,5.9,7.9,10.8,22.7,24.2l2.2,2L38.2,58.4z" />
	</svg>
);

export default shortlist;


// WEBPACK FOOTER //
// ../q-components/components/icons/searchIcons/shortlist/index.js